module.exports = __webpack_public_path__ + "img/kjx.f2f6bd3a.png";